import { lazy } from 'react';
const AccountPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/account',
      component: lazy(() => import('./AccountPage')),
    },
    {
      path: '/subscriptions-company',
      component: lazy(() => import('./SubscriptionsCompany')),
    },
  ],
};
export default AccountPageConfig;
